import { useConfigContext } from 'redesign/components/common/contexts/ConfigManager';
import { CompanyName } from 'redesign/constants/config';

export const useUserCompany = () => {
    const { config } = useConfigContext();

    if (config.company === CompanyName.EMPTY) {
        return undefined;
    }
    if (config.company === CompanyName.SELLER) {
        return config.tenant_name;
    }
    return config.company;
};
